import React, { Component } from "react"
import { connect } from 'react-redux'
import { saveTransactionAction } from '../../redux/actions/MainAction'
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

class EvaluationModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
        }


        this.handleChange = this.handleChange.bind(this)
    }

    componentDidUpdate() {
        console.log('EvaluationModal:componentDidUpdate')
    }

    componentWillReceiveProps() {
        console.log('EvaluationModal:componentWillReceiveProps')
    }

    handleChange(event) {
    }
    
    render() {
        console.log("EvaluationModal.render()")

        const useStyles = makeStyles({
            root: {
              minWidth: 275,
            },
            bullet: {
              display: 'inline-block',
              margin: '0 2px',
              transform: 'scale(0.8)',
            },
            title: {
              fontSize: 14,
            },
            pos: {
              marginBottom: 12,
            },
          });
          

        let {  t_MR_EVAL,t_PO_DETAIL,t_MR_DETAIL } = this.props

        return (
            <div className="modal fade sp-modal rrs-modal" id="addEvaluationModal" tabIndex={-1} role="dialog" aria-labelledby="addEvaluationModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content" style={{border:0}}>
                        <div className="modal-header">
                            <h5 className="modal-title" id="addEvaluationModalLabel">
                                {'ข้อมูลที่เกี่ยวข้องกับการประเมิน'}
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container" style={{paddingTop:35}}>
                            

                        {
                            (t_MR_EVAL && t_MR_EVAL.length>0) &&
                            (<div className="rrs-detail3">
                                <Card>
                                    <CardContent>
                                        <Typography variant="h5" component="h2" className={{marginBottom: 12}}>
                                        PO / Contract
                                        </Typography>  
                                        <Typography variant="body2" component="p">
                                        PO / Contract No :   <span style={{fontWeight:"bold"}}>{t_PO_DETAIL?t_PO_DETAIL.po_contract_no:'-'}</span>
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                        PR No : <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].prNo?t_MR_EVAL[0].prNo:'-'}</span>
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                        Vendor : <span style={{fontWeight:"bold"}}>{t_PO_DETAIL?t_PO_DETAIL.vendor_name:'-'}</span>
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                        Purchase Organization : <span style={{fontWeight:"bold"}}>{t_PO_DETAIL?t_PO_DETAIL.puR_CH_ORG:'-'}</span>
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                        Purchase Group : <span style={{fontWeight:"bold"}}>{t_PO_DETAIL?t_PO_DETAIL.puR_CH_GROUP:'-'}</span>
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                        Net Price : <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].net_price?require('numeral')(t_MR_EVAL[0].net_price).format('0,0.00') + ' บาท':'-'} </span> 
                                        </Typography>
                                        {t_MR_EVAL[0] && t_MR_EVAL[0].command_method === 'พัสดุ' &&(<div>
                                                <Typography variant="body2" component="p">
                                                Tax Code : <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].tax_rate && t_MR_EVAL[0].tax_code?t_MR_EVAL[0].tax_code+' ( '+t_MR_EVAL[0].tax_rate+ '% )':'-'} </span> 
                                                </Typography>
                                                <Typography variant="body2" component="p">
                                                Amount (includeTax) : <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].amount?require('numeral')(t_MR_EVAL[0].amount).format('0,0.00') + ' บาท':'-'} </span> 
                                                </Typography>
                                        </div>)}
                                        <Typography variant="body2" component="p">
                                        ชุดแบบสอบถามชุดใหม่ : <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0].is_new_evaluation === true ? 'ใช่': 'ไม่ใช่'}</span>
                                        </Typography>
                                    </CardContent>
                                </Card>

                                <br></br>
                                <Card className={{minWidth: 275}}>
                                    <CardContent>
                                        <Typography variant="h5" component="h2" className={{marginBottom: 12}}>
                                        TOR Online
                                        </Typography>  
                                        <Typography variant="body2" component="p">
                                        ระบบมาตรฐานที่เกี่ยวข้อง Energy :  <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].is_enrgy != null? t_MR_EVAL[0].is_enrgy == true ? 'ใช่': 'ไม่ใช่' : '-'}</span>
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                        แบบประเมินความเสี่ยง SSHE :  <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].is_sshe != null ? t_MR_EVAL[0].is_sshe == true ? 'ใช่': 'ไม่ใช่' : '-'}</span>
                                        </Typography>
                                    </CardContent>
                                </Card>
                                <br></br>
                                <Card className={{minWidth: 275}}>
                                    <CardContent>
                                        <Typography variant="h5" component="h2" className={{marginBottom: 12}}>
                                        Project Creation
                                        </Typography> 
                                        <Typography variant="body2" component="p">
                                        ระเบียบ :  <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].command_method?t_MR_EVAL[0].command_method:'-'}</span>
                                        </Typography> 
                                        <Typography variant="body2" component="p">
                                        ประเภทการจัดหา :  <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].command_type?t_MR_EVAL[0].command_type:'-'}</span>
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                        วิธีการจัดหา :  <span style={{fontWeight:"bold"}}>{t_MR_EVAL[0] && t_MR_EVAL[0].procmethod_cat?t_MR_EVAL[0].procmethod_cat:'-'}</span>
                                        </Typography>
                                    </CardContent>

                                

                                </Card>
                                <div className="row mx-0 header-button-row mt-0">
                                        <div className="col-12 sp-header-button-panel2">
                                        <a href="#" className="sp-btn-icon btn-del" data-dismiss="modal" onClick={this.onCancleHandler}>
                                                    <i className="icon btn-order-delete"></i><span className="sp-btn-icon-label">Close</span>
                                                </a>
                                        </div>
                                    </div>
                                </div>)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, MasterRedux } = state
    return {
        t_MR_EVAL: MainRedux.t_MR_EVAL,
        t_PO_DETAIL: MainRedux.t_PO_DETAIL,
        t_MR_DETAIL: MainRedux.t_MR_DETAIL,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        saveTransaction: (transaction) => dispatch(saveTransactionAction(transaction)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EvaluationModal)